import { ALMOST_WHITE, IRON, NAVY } from 'styles/Colors';
import {
  AUTH_MFA_LOCKED,
  AUTH_MFA_UPDATE_PHONE
} from 'portal/constants/Routes';
import { startVerify, validateCode } from 'auth/MfaLoginApiCalls';
import Container from '@opploans/container-component/Container';
import LinkButton from '@opploans/link-button-component/LinkButton';
import MfaActionButtons from '@opploans/mfa-action-buttons-component/MfaActionButtons';
import React, { useState } from 'react';
import ValidateCode from '@opploans/validate-code-component/ValidateCode';

const showError = () => {
  window.toastr.error(null, 'Message could not be delivered to your device.', {
    timeOut: 0,
    extendedTimeOut: 0
  });
};

const containerStyle = {
  textAlign: 'center',

  h1: {
    color: NAVY,
    fontSize: '1.5rem',
    fontWeight: 700
  },

  h2: {
    fontSize: '1.25rem'
  }
};

export const subtextStyle = {
  fontSize: '0.75rem',
  fontStyle: 'italic'
};

function MfaLogin({ navigate }) {
  const [channel, setChannel] = useState();
  const [codeSent, setCodeSent] = useState(false);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const maskedPhoneNumber = `(***) ***-${window.AppConfigState.user_phone_last_four}`;
  const fromPhoneNumberChange =
    window.location.search?.indexOf('phone_update_complete=true') >= 0;

  const startTextConfirmation = (channelParam = channel) => {
    setLoading(true);

    startVerify(channelParam).then((response) => {
      if (response.status === 200) {
        setCodeSent(true);
      } else if (response.data?.data?.locked) {
        navigate(AUTH_MFA_LOCKED);
      } else {
        showError();
      }

      setLoading(false);
    });
  };

  const validateTextConfirmation = () => {
    setLoading(true);

    validateCode(code).then((response) => {
      if (response.status === 200) {
        setError(false);
        window.location.href = response.data.data.redirect_to;
      } else if (response.data?.data?.locked) {
        navigate(AUTH_MFA_LOCKED);
      } else {
        setError(true);
        setLoading(false);
      }
    });
  };

  const handleChangeNumber = () => {
    navigate(AUTH_MFA_UPDATE_PHONE);
  };

  return (
    <Container additionalStyle={containerStyle}>
      {!codeSent && (
        <>
          {fromPhoneNumberChange && (
            <>
              <h1>Multi-Factor Authentication</h1>
              <p css={{ fontWeight: 'bold' }}>
                Your phone number has been updated!
              </p>
              <p>
                To complete the MFA process, we&apos;ll send a one-time
                identification code to your phone.
              </p>
            </>
          )}
          {!fromPhoneNumberChange && (
            <>
              <h1>Let&apos;s Verify Your Identity</h1>
              <p css={{ textAlign: 'left' }}>
                We need to verify your identity before you can log in.
                We&apos;ll send a one-time identification code to your phone.
              </p>
              <div
                css={{
                  border: `1px solid ${IRON}`,
                  borderRadius: '0.25rem',
                  background: ALMOST_WHITE,
                  padding: '1rem'
                }}
              >
                The phone number we have on file is{' '}
                <span data-testid='masked-phone' css={{ whiteSpace: 'nowrap' }}>
                  {maskedPhoneNumber}
                </span>
                <LinkButton
                  lightBackground
                  additionalStyle={{
                    textDecoration: 'underline',
                    marginTop: '1rem'
                  }}
                  onClick={handleChangeNumber}
                >
                  This number is incorrect
                </LinkButton>
              </div>
            </>
          )}
          <MfaActionButtons
            handleSend={startTextConfirmation}
            loading={loading}
            channel={channel}
            setChannel={setChannel}
          />
        </>
      )}

      {codeSent && (
        <ValidateCode
          code={code}
          setCode={setCode}
          handleVerify={validateTextConfirmation}
          handleSend={startTextConfirmation}
          handleBack={() => setCodeSent(false)}
          loading={loading}
          maskedPhoneNumber={maskedPhoneNumber}
          error={error}
        />
      )}
    </Container>
  );
}

export default MfaLogin;
